import React, { useState, Fragment } from 'react';
import systolicImg from '../../assets/Images/blood-pressure.png';
import diastolicImg from '../../assets/Images/diastolic.png';
import pulseImg from '../../assets/Images/pulse.png';
import { Image } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { commentOnReading, commentOnReadingByStaff } from '../../actions/HRActions';
import { ReadingCommentNote } from '../HR/ClinicalNote';
import { useAlert } from 'react-alert';
import patientProfileImg from '../../assets/Images/doctorIcon.png';
import { Link } from 'react-router-dom';
import { sysCategory, diaCategory } from '../../utils/bpCategory';
import { formatClinicianName } from '../../utils/clinicianName';
import { formatDate, formatDateTime } from '../../utils/dateFormat';

const moment = require('moment-timezone');

const CuffTelemetaryData = ({ healthData, isAdmin, patientId}) => {
    let color;
    const  dispatch = useDispatch();
    const alert = useAlert();

    const { user} = useSelector(state => state.auth);

    let telemetaryData = healthData?.telemetaryData;
    let deviceDetails = healthData?.deviceId;
    let notes = healthData?.notes;

    const [comment, setComment] = useState('');



    const commentHandler = (readingId) => {
        if(user?.role === 'HrMedical'){
            if(comment.length === 0 ){
                alert.error('You cannot add empty commment');
                return;
            }

            let notes = `${comment}. His / Her reading are ${telemetaryData?.sys} / ${telemetaryData?.dia} and pulse is ${telemetaryData?.pul} and receiving time of the reading is
                ${formatDateTime(telemetaryData?.ts * 1000)}`
            
            dispatch(commentOnReading(readingId, user?._id, comment, patientId, notes));
        } else {
            if(comment.length === 0 ){
                alert.error('You cannot add empty commment');
                return;
            }

            dispatch(commentOnReadingByStaff(readingId, user?._id, comment));
        }
    }

    let sysBPCategory; //variable to store category of BP

    function calcSysBpCategory(sys) {
        const c = sysCategory(sys);
        sysBPCategory = c.label;
        color = c.color;
    }

    let diaBpCategory;

    function calcDiaBpCategory(dia) {
        const c = diaCategory(dia);
        diaBpCategory = c.label;
        color = c.color;
    }
    
    return <Fragment> 
      <>
      <div className="card p-3 m-2">
        <br />
          <div className="row">
            <div className="col-md-1">
                <Image src={systolicImg} className="systolic-image" />    
            </div>

            {calcSysBpCategory(telemetaryData?.sys)} 
                
            <div className="col-md-3">
            <span className="profile-label">Systolic : {
                                telemetaryData?.sys >= 139 || telemetaryData?.sys <= 110 ? 
                                <span style={{color: 'red'}}>{telemetaryData?.sys}</span> : 
                                <span>{telemetaryData?.sys}</span>} mmHG </span>
                <br/>
                <small>{sysBPCategory} &nbsp;&nbsp;&nbsp;<i className='bx bxs-circle' style={{color: color, fontSize: '22px'}}></i></small>  
            </div>

            <div className="col-md-1">
                <Image src={diastolicImg} className="systolic-image" />    
            </div>

            {calcDiaBpCategory(telemetaryData?.dia)}

            <div className="col-md-3">
            <span className="profile-label">Diastolic : {telemetaryData?.dia >= 90 || telemetaryData?.dia <= 70 ? 
                                <span style={{color: 'red', fontWeight: 'bold'}}>{telemetaryData?.dia}</span> : 
                                <span>{telemetaryData?.dia}</span>} mmHG</span>
                <br/>
                <small>{diaBpCategory} &nbsp;&nbsp;&nbsp;<i className='bx bxs-circle' style={{color: color, fontSize: '22px'}}></i></small>
            </div>

            <div className="col-md-1">
                <Image src={pulseImg} className="systolic-image" />    
            </div>

            <div className="col-md-2">
                <span className="profile-label">Pulse : {telemetaryData?.pul} bpm</span>
            </div>

            {isAdmin ===true ? <>
                <div className="col-md-1">
                    <Link to={{ pathname: "/edit/telemetarydata", state: {telemetaryData: healthData}}} className="btn btn-link">Edit</Link>
                </div>
            </> : null }

        </div> {/* First Row Ends here */}

        {/* Device & Patient Info */}
        <br />
        <div className="row-display telemetary-patient-row pl-2 pr-2">
                {/* <div className="col-md-7"> */}
                    <span>Device ID: &nbsp;&nbsp;{deviceDetails?._id}</span>

                    <span className="ml-2">Data Sent Date: &nbsp;&nbsp; {formatDateTime(telemetaryData?.ts * 1000)}</span>

                    <span className="ml-2">Data Receiving Date: &nbsp;&nbsp; {formatDate(healthData?.createdAt)}</span>
                {/* </div> */}
            </div>


            
            {isAdmin ===true ? <Fragment>
            </Fragment> : 
                <div className="row mt-4">
                    <div className="col-md-10">
                        <input type="text" 
                        className="form-control"
                        placeholder="Type your comment here ....."
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        key={telemetaryData?._id}
                        />
                    </div>
    
                    <div className="col-md-2">
                        <button className="edit-pill" type="submit" onClick={() => commentHandler(healthData?._id)}>Add Comment</button>
                    </div>
                </div>
            } 
            

            {/* Comment */}
            {notes.length > 0 && notes.map((note, index) => ( <div key={index}>
                <div className="row-display-secondary">
                    <div className="mt-3 mr-3">
                        <img src={patientProfileImg} alt="hr/drImg" style={{width: '50px', height: '50px', borderRadius: '50%'}}/>
                    </div>
                    <div className="bubble bubble-alt">  
                        
                        <span>{note?.conclusion_hr_id ? (<span style={{color: '#EAE2B7'}}>{note?.conclusion_hr_id?.lastname}, {note?.conclusion_hr_id?.firstname}</span>) : (<span style={{color: '#EAE2B7'}}>
                           {formatClinicianName(note?.conclusion_doctor_id)}
                        </span>)}</span><br/>
                                               
                        <p className="mt-1 mr-3"><ReadingCommentNote note={note} user={user} onChanged={() => window.location.reload()} /> <br/> 
                         <p className="mt-1" style={{letterSpacing: '1px'}}>{formatDateTime(note?.dateTime)}</p>
                        </p>
                    </div>
                </div>
            </div> 
            ))}  
        </div>
      </>
      
    </Fragment>;   
};


export default CuffTelemetaryData;
